import { render, staticRenderFns } from "./RisksAndAlerts.vue?vue&type=template&id=648efcb6"
import script from "./RisksAndAlerts.vue?vue&type=script&lang=ts"
export * from "./RisksAndAlerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648efcb6')) {
      api.createRecord('648efcb6', component.options)
    } else {
      api.reload('648efcb6', component.options)
    }
    module.hot.accept("./RisksAndAlerts.vue?vue&type=template&id=648efcb6", function () {
      api.rerender('648efcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/RisksAndAlerts.vue"
export default component.exports